import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/reducers'

const useWatchlists = () => {
  const myWatchlists = useSelector((state: AppState) => state.watchlists.watchlists)
  const idsMap = useMemo(() => {
    let idMap = new Map()
    Object.values(myWatchlists)
      .map(wl => wl.playerIds)
      .flat()
      .forEach(id => idMap.set(id, true))
    return idMap
  }, [myWatchlists])

  const isPlayerWatched = useCallback(playerId => idsMap.get(playerId) || false, [idsMap])

  return {
    isPlayerWatched,
  }
}

export default useWatchlists
